//export const SERVER_BASE_URL = 'http://localhost:59837/';
// export const SERVER_BASE_URL = 'http://192.168.1.107:45455/';
// export const SERVER_BASE_URL = 'http://10.100.102.6:45455/';
// export const SERVER_BASE_URL = 'http://u515.utron-parking.com:45456/';
// export const SERVER_BASE_URL = 'https://utrongmtservertest.azurewebsites.net/'; //TEST
//export const SERVER_BASE_URL = 'https://utrongmtserverdev.azurewebsites.net/'; //DEV
export const SERVER_BASE_URL = 'https://utrongmtserverprod.azurewebsites.net/'; // PROD

// export const AZURE_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY = 'e292ca14-5c63-4c37-a914-792b28e246b2'; //TEST
//export const AZURE_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY = '86728d7d-34c2-474c-a444-d4f534c14e49'; //DEV
export const AZURE_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY = 'c8ac5fa5-3811-47dd-9655-f0f4dc71e1ce'; //PROD

export const UTRON_EMAIL = "utron-parking.com";
export const UTRON_DUMMY_EMAIL = "utron-dummy-email.com";
export const PARKERS_TABLE_ID='2';
export const GUESTS_TABLE_ID='3';
export const GMT_TABLE_ID='4';

export const LENGTHS = {
    TO_FIXED_LENGTH: 2,
    MIN_PHONE_NUMBER_LENGTH: 9, // Digits
    MAX_PHONE_NUMBER_LENGTH: 15, // Digits
    MAX_INPUT_LENGTH: 30, // Chars
    MAX_TEXT_MESSAGE_LENGTH: 75, // SMS
    MAX_HTML_BODY_MESSAGE_LENGTH: 500, // Email body
    MAX_ATTACHMENT_FILE_SIZE: 500, // KB
    MAX_ASSIGNED_NUMBER_PER_TOKEN_LENGTH : 5
};

export const TIMEOUTS = {
    REQUEST_TIMEOUT: 45 * 1000,
    SESSION_LOGOUT_TIME: 20 * 60 * 1000 // 2O Minutes
};